import { useEffect, useState } from 'react';
import { useLabAnswers } from '../contexts/LabAnswersContext';

export default function useQuestionAnswer(questionId, emptyValue) {
  const context = useLabAnswers();
  const candidate = context?.answers?.[questionId];
  const compatible = !candidate || (Array.isArray(emptyValue) ? Array.isArray(candidate.currentAnswer) : typeof candidate.currentAnswer === 'string');
  const stored = compatible ? candidate : undefined;
  useEffect(() => {
    if (!compatible) context?.reportStorageError?.('A saved answer has an incompatible format. Its stored copy has been kept; check your work before editing it.');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [compatible]);
  const [answer, setAnswer] = useState(stored?.currentAnswer ?? emptyValue);
  const [result, setResult] = useState(stored?.isChecked ? stored.isCorrect : null);
  useEffect(() => {
    setAnswer(stored?.currentAnswer ?? emptyValue);
    setResult(stored?.isChecked ? stored.isCorrect : null);
    // Only this question's record can restore its value. Other questions cannot reset it.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stored, questionId]);
  function change(next) {
    setAnswer(next);
    setResult(null);
    context?.updateDraft?.(questionId, next);
  }
  function check(correct) {
    if (correct === null) {
      setResult('empty');
      return;
    }
    setResult(correct);
    context?.recordAnswer?.(questionId, answer, correct);
  }
  return { answer, result, change, check };
}
